module.exports = __webpack_public_path__ + "assets/1f2913c2f4a2f2c4be7c34eed13718f5.mp3";